import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  AbsoluteCenterFeatureContainer,
  PostMagazineArticleCenterFeatureContainer,
  PostMagazineArticleCenterSectionWrapper,
  PostMagazineLeftWrapper,
  PostMagazineLogoWrapper,
} from "scmp-app/components/header/styles";

export const getPostMagazineArticleLayout = ({
  features,
  shouldSwap,
}: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <>
      <PostMagazineArticleCenterFeatureContainer>
        <PostMagazineArticleCenterSectionWrapper>
          {features.section({
            isPostMagazineArticle: true,
            shouldSwap,
            showIn: "desktopUp",
            showOnSwap: true,
            size: "small",
            variant: "center",
          })}
        </PostMagazineArticleCenterSectionWrapper>
        {features.articleHeadline({
          display: "block",
          isPostMagazineArticle: true,
          shouldSwap,
          showIn: "desktopUp",
          showOnSwap: true,
        })}
      </PostMagazineArticleCenterFeatureContainer>
      <AbsoluteCenterFeatureContainer>
        {features.postMagazineOnelineMenu({
          hideOnSwap: true,
          shouldSwap,
          showIn: "desktopUp",
        })}
        <PostMagazineLogoWrapper>
          {features.postMagazineLogoLink({
            hideOnSwap: true,
            shouldSwap,
            showIn: "mobileAndTablet",
          })}
          {features.postMagazineLogoTextLink({
            hideOnSwap: true,
            shouldSwap,
            showIn: "mobileAndTablet",
          })}
        </PostMagazineLogoWrapper>
      </AbsoluteCenterFeatureContainer>
    </>
  ),
  left: (
    <>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      <PostMagazineLeftWrapper>
        <PostMagazineLogoWrapper>
          {features.postMagazineLogoLink({
            hideOnSwap: true,
            shouldSwap,
            showIn: "desktopUp",
          })}
          {features.postMagazineLogoTextLink({
            shouldSwap,
            showIn: "mobileAndTablet",
            showOnSwap: true,
          })}
          {features.postMagazineLogoTextLink({
            showIn: "desktopUp",
          })}
        </PostMagazineLogoWrapper>
        {features.search({
          hideOnSwap: true,
          shouldSwap,
          showDesktopDivider: true,
          showIn: "mobileUp",
        })}
      </PostMagazineLeftWrapper>
    </>
  ),
  right: (
    <>
      {features.share({ shouldSwap, showIn: "mobileUp", showOnSwap: true })}
      {features.bookmark({ shouldSwap, showIn: "mobileUp", showOnSwap: true })}
      {features.comment({ shouldSwap, showIn: "mobileUp", showOnSwap: true })}
      {features.subscription({
        fallback: features.myNews({
          hideOnSwap: true,
          shouldSwap,
        }),
        showIn: "desktopUp",
        variant: "dark",
      })}
      {features.myNews({
        hideOnSwap: true,
        shouldSwap,
        showIn: "mobileAndTablet",
        showWhenLoggedIn: true,
      })}
      {features.dashboard({
        hideOnSwap: true,
        shouldSwap,
        showIn: "mobileUp",
        variant: "postmag",
      })}
    </>
  ),
});
